export default "__VITE_ASSET__DPL6Hu9n__"